const article = {
    id: 'sku-scan-history',
    title: 'SKU scan history',
    summary: 'Open a SKU and view the scan history without leaving the SKU details.',
    publishedAt: '2026-09-11',
    tags: ['skus', 'scan'],
    sections: [
        {
            type: 'paragraph',
            text: 'SKU details include an Activity timeline. Scan events are in that timeline, with the rest of the SKU history.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when you need to trace where a SKU was scanned, or to check a step that does not match the current status.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Skus and open the SKU.',
                'Find Activity in the details.',
                'Use the Scans filter to see scan events.',
            ],
        },
    ],
};

export default article;
